//#region lib import
import axios from "axios";
//#endregion

//#region functions import
import { getApiServerProPath } from "../Helper/ReadWriteApiPath";
//#endregion

//#region constants import
import { URI } from "../Constants/ApiConstants";
//#endregion

export const postFeatureLog = async (centerId, logValue) => {
  if (process.env.NODE_ENV === "test") {
    return "";
  }

  const { data } = await axios.post(`${getApiServerProPath()}/${URI.Entity.Datas}/${URI.Entity.Centers}/${centerId}/${URI.Property.FeatureLog}`, 
    {
      logType: "DOWNLOAD_NOTICE",
      logValue: logValue 
    }
  );

  return data;
};
